import FormOptionCard from '@anwb/poncho/components/form-option-card';

import { LeaseCarDuration } from '../../../../../types';

type DurationFullProps = {
	availableDurations: LeaseCarDuration[];
	handleChange: (selectedOptions: string | string[]) => void;
	selectedValue: string;
	isFlex: boolean;
};

export const DurationFull = ({
	availableDurations,
	handleChange,
	selectedValue,
	isFlex,
}: DurationFullProps) => (
	<FormOptionCard
		key={availableDurations.length}
		name="duration"
		dataTest="duration"
		inputType="radio"
		columns={2}
		onChange={handleChange}
		preselectedOptions={[selectedValue]}
		required
	>
		{availableDurations.map((duration: LeaseCarDuration) => (
			<FormOptionCard.Item
				key={duration.name}
				label={
					isFlex
						? `Na ${duration.name} maanden, gratis per maand opzegbaar`
						: `${duration.name} maanden`
				}
				value={duration.name}
				subTitle={duration.price ? `€ ${duration.price} per maand` : 'Geen extra kosten'}
				subTitleSize="small"
			/>
		))}
	</FormOptionCard>
);
